<template>
  <div class="ps-table-wrap">
    <ve-table
       :fixed-header="true"
        :columns="columns"
        :max-height="'calc(100vh - 210px)'"
        :sort-option="sortOption"
      :table-data="tableData"
      :border-around="true"
    />
    <empty-state v-if="showEmptyResult" :title="$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.NO_RECORDS')" />
    <SpinnerWithMessage
      :isLoading="isLoading"
      :message="$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.LOADING')"
      className="py_20 px_20"
    />
  </div>
</template>


<script>
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import alertMixin from 'shared/mixins/alertMixin';
import SpinnerWithMessage from "shared/components/SpinnerWithMessage.vue";
import helperMixin from 'shared/mixins/helperMixin';
import Label from 'dashboard/components/ui/Label';
import copy from 'copy-text-to-clipboard';

export default {
    components:{
    VeTable,
    Spinner,
    EmptyState,
    SpinnerWithMessage,
    Label,
  },
  mixins: [alertMixin, helperMixin,],
  props:{
    records:{
      type: Array,
      default: () => []
    },
    cols: {
      type: Array,
      default: () => [],
    },
    showEmptyResult: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      sortConfig: {},
      sortOption: {
        sortAlways: true,
        sortIcons: {
          ascend: "top-arrow",
          descend: "bottom-arrow"
        },
        sortChange: params => this.$emit('on-sort-change', params),
      },
    }
  },
  computed: {
        tableData() {
          if (this.isLoading) {
              // return [];
          }
          return this.records;
        },
        columns(){
            let matches = {};


            matches.title = {
              field: 'title',
              key: 'title',
              title: 'Title',
              width: 160,
              align: 'left',
              renderBodyCell: ({ row }) =>{
                const elipsText = this.trimAndEllipsText(row.title,100);
                return <span>{elipsText}</span>
              },
            };
            matches.description = {
              field: 'description',
              key: 'description',
              title: 'Description',
              width: 160,
              align: 'left',
              renderBodyCell: ({ row }) => {
                const elipsText = this.trimAndEllipsText(row.description,100);
                return <span>{elipsText}</span>
              },
            };

            matches.status = {
              field: 'status',
              key: 'status',
              title: 'Status',
              width: 80,
              align: 'center',
              renderBodyCell: ({ row }) => {
                let colorSchema = 'secondary';
                    switch (row.status) {
                        case 'cancelled':
                            colorSchema = 'secondary'
                            break;
                        case 'active':
                        // case 'running':
                          colorSchema = 'success'
                            break;
                        // case 'completed':
                        //   colorSchema = 'secondary'
                        //   break;
                        // case 'deactivate':
                        //     colorSchema = 'warning'
                        //     break;

                        default:
                            break;
                    }
                return <Label title={row.status} colorScheme={colorSchema} />
              },
            };
            matches.location = {
              field: 'location',
              key: 'location',
              title: 'Location',
              // width: 160,
              align: 'left',
              // add copy
              renderBodyCell: ({ row }) => <span>{row.location}</span>,
            };
            matches.friendly_time = {
              field: 'friendly_time',
              key: 'friendly_time',
              title: 'Scheduled',
              width: 160,
              align: 'left',
              renderBodyCell: ({ row }) => <span>{row.friendly_time}</span>,
            };


            matches.actions = {
                field: 'actions',
                key: 'actions',
                title: 'Actions',
                fixed: 'right',
                align: 'center',
                width: 100,
                renderBodyCell: ({ row }) => (
                    <div className="actions-wrapper">
                    <woot-button
                        variant="smooth"
                        color-scheme="secondary"
                        icon="copy"
                        size="small"
                        class-names="margin-right-button"
                        onClick={() => this.copyLink(row)}
                    />
                    </div>
                ),
            };






            const preSet = [];
            this.cols.forEach(col=>{
              if (col.visible) {
                if (col.key in matches) {
                  preSet.push(matches[col.key])
                }
              }
            })
            return preSet;
        },
    },
    methods:{
        copyLink(item){
            copy(item.location);
            this.showAlert('Link Copied');
        },
    },

}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_ps_table.scss';

.actions-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

}

</style>